// extracted by mini-css-extract-plugin
export default {"DelayNavigatePage":"DelayNavigatePage_DelayNavigatePage__E-uth"};